import { render, staticRenderFns } from "./SendMessageDialog.vue?vue&type=template&id=6318eea0&"
import script from "./SendMessageDialog.vue?vue&type=script&lang=js&"
export * from "./SendMessageDialog.vue?vue&type=script&lang=js&"
import style0 from "./SendMessageDialog.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports